import styled, { css } from 'styled-components';
import { animated } from 'react-spring';

import { tokens } from '../../../../design/tokens';

interface ToastProps {
  type?: 'success' | 'info' | 'error';
  description: number;
}

/*
 * Os tres tipos usavam cores proprias, nenhuma do sistema:
 *   info    #ffd817 — um TERCEIRO amarelo, alem do Ouro de Marquise
 *                     (#fed44a) e do #ffd35c ja corrigido nas telas de aula
 *   success #e6fffa / #2e656a — verde-agua, cor que nao existe na paleta
 *   error   #fddede / #c53030 — o texto ja era o Vermelho de Erro do
 *                     sistema, mas sobre um rosa claro de tema claro
 *
 * Agora: `info` assume o ouro com Carvao de Tinta por cima (o par de
 * contraste documentado); `success` e `error` mantem a distincao semantica
 * pelo texto e pela borda, sobre o degrau tonal escuro do sistema — em vez de
 * tres retangulos claros aparecendo sobre um app preto.
 */
const toastTypes = {
  info: css`
    background: ${tokens.color.marqueeGold};
    color: ${tokens.color.inkCharcoal};
  `,
  success: css`
    background: ${tokens.color.cardCharcoal};
    color: ${tokens.color.textWhite};
    border-left: 4px solid ${tokens.color.marqueeGold};
  `,
  error: css`
    background: ${tokens.color.cardCharcoal};
    color: ${tokens.color.textWhite};
    border-left: 4px solid ${tokens.color.errorRed};
  `,
};

export const Container = styled(animated.div)<ToastProps>`
  width: 360px;
  max-width: 100%;

  & + div {
    margin-top: 8px;
  }

  position: relative;
  padding: 16px 30px 16px 16px;
  border-radius: 10px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);

  display: flex;

  ${(props) => toastTypes[props.type || 'info']}

  > svg {
    margin: 4px 12px 0 0;
  }

  div {
    flex: 1;

    p {
      margin-top: 4px;
      font-size: 14px;
      opacity: 0.7;
      line-height: 20px;
    }
  }

  button {
    position: absolute;

    right: 16px;
    top: 19px;
    opacity: 0.6;

    border: 0;
    background: transparent;
    color: inherit;
  }

  ${(props) =>
    !props.description &&
    css`
      align-items: center;

      svg {
        margin-top: 0;
      }
    `}
`;
